<script lang="ts">
    import { Col, FormGroup, Input, Label, Row } from "sveltestrap";
    import { MaximumLength, StaticText, Textarea } from "../../../../utils/Constant/Constant";
</script>

<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{MaximumLength}</Label>
    </Col>
    <Col sm="9">
      <Input type="text"
        placeholder="Content must be in 6 characters"
        maxLength="6" />
    </Col>
  </Row>
</FormGroup>
<FormGroup class="row">
  <Row>
    <Col sm="3">
      <Label class="col-form-label pt-0">{StaticText}</Label>
    </Col>
    <Col sm="9">
      <div class="form-control-static">
        {'Hello !... This is static text'}
      </div>
    </Col>
  </Row>
</FormGroup>
<Row class="mb-0">
  <Col sm="3">
    <Label class="col-form-label">{Textarea}</Label>
  </Col>
    <Col sm="9">
      <textarea
        class="form-control"
        rows="5"
        cols="5"
        placeholder="Default textarea" />
    </Col>
</Row>